// extracted by mini-css-extract-plugin
module.exports = {"toggleSort":"About_toggleSort__3Ui17"};